


import React, {useState, useEffect, useContext, useMemo} from "react";
import Footer from "../Components/Footer/Footer";
import Slider from "react-slick";


// Icons 
import PremierBanner from "../Images/premier-banner-bg-1-1@3x.png";
import KMLogo from "../Images/KM logo@2x.png";
import CallIcon from "../Images/Group 267@3x.png";
import YellowTickIcon from "../Images/Group 3077@3x.png";
import AdvisorIcon from "../Images/Group 3227.svg";
import AccurateIcon from "../Images/Group 3228.svg";
import VisibilityIcon from "../Images/Group 3216.svg";
import MeetIcon from "../Images/Group 3229.svg";
import HoroScopeIcon from "../Images/Group 3230.svg";
import ServiceIcon from "../Images/Group 3231.svg";
import EngagedIcon from "../Images/220-SM775038.png";
import CallerIcon from "../Images/Group 3239.svg";
import HoroIcon from "../Images/Group 3242.svg";
import PhoneBookIcon from "../Images/Group 3240.svg";
import ChatIcon from "../Images/Group 2141.svg";
import StatIcon from "../Images/Group 3243.svg";
import MobEngagedIcon from "../Images/Mask Group 42@3x.png";
import MobileIcon from "../Images/Group 3302@2x.png";

import {useDispatch, useSelector} from "react-redux"
import { getMemberShipDetail, payNow } from "../Store/Payment/Action";
import Constants from "../Constants/constants";
import Loader from "../Components/Loader";
import { useFormik } from "formik";
import * as Yup from "yup";
import EndPoints from "../Constants/EndPoints";
import config from "../config";
import { GET, POST } from "../Services/api_services";
import { LoginContext } from "../Contexts/LoginContext";
import { convertToCurrency, validateNumber } from "../Utils";
import { useNavigate } from "react-router";
import { CommonSuccessPopup } from "../Components/CommonPopup";
import { useTranslation } from "react-i18next";
import FormPopup from '../Components/HomeRegisterContent/FormPopup';
import { useAnalytics } from '../Hooks/usePageChange';
import { NewKalyanPremierTrack} from '../Constants/constants';
import { NavBarContext } from "../Contexts/NavBarContext";




function NewKalyanPremier() {


const dispatch = useDispatch()
const navigate = useNavigate()
const [showLoader, setShowLoader] = useState(true);
const [isdCodeList, setIsdCodeList] = useState([]);
const [memberShipDetail, setMemberShipDetail] = useState(null);
const [showSuccessPopup, setshowSuccessPopup] = useState(false);
const [showRegisterPopup, setshowRegisterPopup] = useState(false);
const [isClick, setIsClick] = useState(false);
const {onClickTrack} = useAnalytics()
const { resetkminterestfor,setResetkminterestfor }= useContext(NavBarContext)

// const { loginDetail, logout } = useContext(LoginContext);

const { t:trans } = useTranslation();


const { payNowResponse } = useSelector((state) => ({
  payNowResponse: state?.Payment?.payNowData,
}));

const apicallIsdCode = async () => {
  let { statusCode, data } = await GET(
    `${config.api.API_URL}${EndPoints.gteIsdCodeUrl()}`
  );

  if (statusCode === 200) {
    setIsdCodeList(data?.data?.isdcode);
  } 
};



const apicallnewpremimerpage = async () => {
  setShowLoader(true);
  let { statusCode, data } = await GET(
    `${config.api.API_URL}${EndPoints.NewkalyanPremierUrl()}`
 );
    if (statusCode === 200) {
      setShowLoader(false);
    setMemberShipDetail(data?.data);
  } else if (statusCode === 401) {
    // logout();
  }
 
}

  

const { premierPack, discountPack, strikeAmount } = useMemo(() => {
  if (memberShipDetail) {
    return {
      premierPack: memberShipDetail?.subscriptionPackages[0],
      discountPack: memberShipDetail?.discountCode ? memberShipDetail?.discountCode[memberShipDetail?.discountCode?.length - 1] : null,
      strikeAmount: memberShipDetail?.strike === "Y"
    }
  }
  return {
    premierPack: null,
    discountPack: null,
    strikeAmount: false,
  }
}, [memberShipDetail])


const getCountryCodeById = (countryId)=> isdCodeList?.find(code=>code.countryId ==countryId)?.isdcode

const apicallSubmit = async (values)=>{
  // setShowLoader(true);
  onClickTrack(NewKalyanPremierTrack.V3_New_Kalyan_Premier_Interest_In_KP_Submit_Button,null,null,"NewKpPage")
  const isdCode = getCountryCodeById(values.isdCode)
  let request = {
    "groomName":values.name,
    "isdcode":isdCode,
    "mobileNumber":values.contactNo
};

  let { statusCode, data } = await POST(
    `${config.api.API_URL}${EndPoints.NewkalyanPremierInterestedUrl()}`,
    request
  );
  // setShowLoader(false);

  if (statusCode === 200) {
    if(data?.data?.Status=="Success"){
      setResetkminterestfor(false);
      setshowRegisterPopup(true);
    setIsClick(true);
    }
  }else if (statusCode === 401) {
    //   logout();
    }
}

  useEffect(() => {
    if (resetkminterestfor) {
      premierForm.resetForm();
    }
  }, [resetkminterestfor]);

const premierForm  =  useFormik({
  initialValues:{
    name:"",
    isdCode:Constants.indiaIsdCodeID,
    contactNo:"",
  },
  validationSchema:Yup.object().shape({
    name:Yup.string().required("Name is required"),
    isdCode:Yup.string().required('Isd code is required'),
    contactNo: Yup.string()
      .test("india", "Phone Number should have 10 digits", function (value) {
        const { isdCode } = this.parent;
        if (isdCode == Constants.indiaIsdCodeID) {
          return !value || value.length === 10 ? true : this.createError({ message: "Phone Number should have 10 digits", path: "contactNo" });
        }
        return true;
      })
      .test("other", "Phone Number should have 10 to 20 digits", function (value) {
        const { isdCode } = this.parent;
        if (isdCode != Constants.indiaIsdCodeID) {
          return !value || (value.length >= 10 && value.length <= 20) ? true : this.createError({ message: "Phone Number should have 10 to 20 digits", path: "contactNo" });
        }
        return true;
      })
      .required("Phone Number is required"),
  }),
  enableReinitialize: true,
  onSubmit:(values)=>{
    apicallSubmit(values)
  }
});


const initialApiCall = async () => {
  await apicallnewpremimerpage()
  await apicallIsdCode()
  setShowLoader(false)
}

useEffect(() => {
  initialApiCall()
}, []);


const payNowClick = ()=>{
    onClickTrack(NewKalyanPremierTrack.V3_New_Kalyan_Premier_Pay_Now_Button,null,null,"NewKpPage");
    setResetkminterestfor(false);
    setshowRegisterPopup(true);
    setIsClick(true);
}



var settings = {
  dots: false,
  infinite: true,
  variableWidth: false,
  slidesToScroll: 1,
  // slidesToShow: 1.3,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
  centerPadding: "60px",
  centerMode: true,
  swipeToSlide: true,
};




  return (
    <>
    {showLoader ? (
        <Loader
          className="loaderTransperancy"
          loaderClassName="loaderTransperancySpin"
        />
      ) : (
        ""
      )}

  {/* Success Message Popup */}

    {/* {showSuccessPopup && (
      <CommonSuccessPopup
        close={() => {
          setshowSuccessPopup(false);
          premierForm.resetForm();
          // navigate(RouteSegments.DASHBOARD);
        }}
        title={"Kalyan Matrimony Service"}
        content={"Success"}
      />
    )} */}

 { showRegisterPopup &&
        <FormPopup isFrom="registerBtn" showPopupRegister={showRegisterPopup} setShowPopupRegister={setshowRegisterPopup} isClick={isClick} setIsClick={setIsClick}/>
      }



      {/* Premier Header Section   */}
      <section className="font-segeo">
        <div className="grid grid-cols-12">
          <div className="col-span-12 md:col-span-7">
            <div className="flex justify-between items-center lg:pl-8 lg:pt-8 md:pl-8 md:pt-8 p-2">
              {/* <img className="h-12 md:h-16 lg:h-24" src={KMLogo} alt="Kalyan Logo" /> */}
              {/* <div className="flex justify-evenly items-center space-x-2">
                <img
                  className="h-[1rem] md:h-[1.8rem] lg:h-8 mt-[1rem] md:mt-[.5rem]"
                  src={CallIcon}
                  alt="CallIcon"
                />
                <div className="leading-[15px] md:leading-[20px] ">
                  <span className="text-[10px] text-[#C4C4C4]">{trans('photo_popup.call_us')}</span>
                  <h5 className="md:text-[1.1rem] lg:text-[1.6rem]">
                    044 4014 6969
                  </h5>
                </div>
              </div> */}
            </div>
            <div className="block md:hidden">
                <img
                  src={MobEngagedIcon}
                  alt="EngagedIcon"
                  className=""
                />
            </div>
            <div className="pr-[2rem] pl-8 lg:pl-12 mt-4">
              <div className="flex gap-2">
                <h1 className="text-[#D10A11] font-bold text-[1.5rem] md:text-[2rem] lg:text-[2.85rem]">
                  KALYAN <span className="text-[#231F20]">PREMIER</span>
                </h1>
              </div>
              <p className="text-[12px] md:text-[16px] lg:text-[26px] lg:tracking-wide italic">
                Our Matrimony Advisor will help you find a great match!
              </p>
              <div className="py-6">
                <p className="font-semibold md:text-[20px] lg:text-[26px] leading-loose tracking-wide">
                  What is Kalyan Premier?
                </p>
                <div>
                  <div className="flex gap-2 my-4">
                    <span className="contents">
                      <img
                        className="h-4 w-4 mt-[2px]"
                        src={YellowTickIcon}
                        alt="TickIcon"
                      />
                    </span>
                    <span className="text-[12px] md:text-[14px] lg:text-[16px]">
                      Our Matrimony Advisor will assist you in finding your
                      perfect match.
                    </span>
                  </div>
                  <div className="flex gap-2 my-4">
                    <span className="contents">
                      <img
                        className="h-4 w-4 mt-[2px]"
                        src={YellowTickIcon}
                        alt="TickIcon"
                      />
                    </span>
                    <span className="text-[12px] md:text-[14px] lg:text-[16px]">
                      Our Matrimony Advisor will shortlist and contact matches
                      on your behalf. We will also facilitate meetings with your
                      prospected match.
                    </span>
                  </div>
                  <div className="flex gap-2 my-4">
                    <span className="contents">
                      <img
                        className="h-4 w-4 mt-[2px]"
                        src={YellowTickIcon}
                        alt="TickIcon"
                      />
                    </span>
                    <span className="text-[12px] md:text-[14px] lg:text-[16px]">
                      Our Matrimony Advisor will assist and guide you on
                      completing your profile to enhance visibility and receive
                      response.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center py-4">
              <button
                type="button"
                onClick={()=>{
                  onClickTrack(NewKalyanPremierTrack.V3_New_Kalyan_Premier_Get_Call_From_Us,null,null,"NewKpPage")
                  document.getElementById('interested-form')?.scrollIntoView({behavior:"smooth"})
                }}
                className="font-segeo flex justify-center px-[2.5rem] md:px-[2.5rem] lg:px-[3rem] py-[.8rem] lg:py-[.8rem] md:py-3 text-left border border-transparent rounded-[3rem] md:rounded-[10px] shadow-sm text-[15px] md:text-[16px] lg:text-[18px] text-[#FFFFFF] font-extrabold bg-[#DF891B] focus:outline-none focus:ring-2 focus:ring-offset-2"
              >
                Get a call from us!
              </button>
            </div>
          </div>
          <div className="col-span-5 hidden md:block">
            <div className="absolute  md:w-[41%] lg:w-[40%] lg:right-[2rem]">
              <div className="flex justify-center item-center relative">
                <div className="md:h-[26rem] lg:h-full">
                  <img src={MobileIcon} className="h-full" alt="MobileIcon" />
                </div>
                {/* <div className="absolute mt-[5px] md:mt-[5px] lg:mt-[10px] md:mr-[6px] lg:mr-[11px]">
                  <div className=" flex justify-center item-center md:h-[25.5rem] md:w-[20.2rem] lg:h-full lg:w-full">
                    <img
                      className="md:w-[50%] lg:w-[50%] h-full"
                      src={MobContentIcon}
                      alt="MobContentIcon"
                    />
                  </div>
                </div> */}
              </div>
            </div>
            <img src={PremierBanner} alt="Banner" className="w-full h-full" />
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section id="interested-form" className="font-segeo bg-[#FBF9F7] py-8">
        <div className="grid grid-cols-12">
          <div className="col-start-2 col-span-11 md:col-start-2 md:col-span-10 lg:col-start-2 lg:col-span-11">
            <p className="font-semibold text-[19px] md:text-[21px] lg:text-[23px] leading-loose md:tracking-wide text-[#575556]">
              Interested in Kalyan Premier?
            </p>
            <p className="text-[13px] md:text-[14px] lg:text-[16px] leading-loose md:tracking-wide text-[#575556]">
              Leave your details below, we will contact you soon.
            </p>
            <form onSubmit={premierForm.handleSubmit}>
            <div className="grid grid-cols-12 mt-6 md:mt-4 lg:space-x-8 md:space-x-4 gap-4 md:gap-4">
              <div className="relative col-span-12 md:col-span-3 lg:col-span-4">
                <label
                  for="name"
                  className="block text-xs lg:text-[14px] font-medium leading-6 text-gray-900"
                >
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  // placeholder="Name"
                  placeholder="Enter Your Name"
                  value={premierForm.values.name}
                  onChange={premierForm.handleChange}
                  className="px-2 w-[20rem] md:w-[13rem] lg:w-[21rem] text-[13px] rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
                 {premierForm.errors.name && (
                      <p className="text-[red] text-[12px]">
                        {premierForm.errors.name}
                      </p>
                    )}
              </div>

              <div className="relative col-span-2 md:col-start-5 md:col-span-1 lg:col-span-1">
                <label
                  for="isdCode"
                  className="block text-xs lg:text-[14px] font-medium leading-6 text-gray-900 whitespace-nowrap"
                >
                  Contact info
                </label>
                <select
                  name="isdCode"
                  onChange={premierForm.handleChange}
                  value={premierForm.values.isdCode}
                  id="isdCode"
                  className="block w-[5rem] md:w-[3rem] lg:w-[5rem] text-[13px] rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                >
                    {isdCodeList?.map((e, i) => (
                      <option key={i} value={e.countryId}>
                        {e.isdcode} {e.country}
                      </option>
                    ))}
                  </select>
                  {premierForm.errors.isdCode && (
                      <p className="text-[red] text-[12px]">
                        {premierForm.errors.isdCode}
                      </p>
                    )}
              </div>

              <div className="relative col-start-4 col-span-9 md:col-span-3 lg:col-span-4">
                <label
                  for="contactNo"
                  className="block text-xs lg:text-[14px] font-medium leading-6 text-gray-900 invisible"
                >
                  Contact info
                </label>
                <input
                  type="text"
                  name="contactNo"
                  placeholder="Enter Your Phone number"
                  value={premierForm.values.contactNo}
                  onChange={(e)=>{
                    if(validateNumber(e.target.value)){
                      premierForm.handleChange(e)
                    }
                  }}
                  id="contactNo"
                  className="px-2 w-[14rem] md:w-[14rem] lg:w-[21rem] text-[13px]  rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
                 {premierForm.errors.contactNo && (
                      <p className="text-[red] text-[12px] whitespace-nowrap">
                        {premierForm.errors.contactNo}
                      </p>
                    )}
              </div>
              <div className="flex justify-center col-span-11 md:col-start-11  md:col-span-2 lg:col-span-2 mt-[1.5rem]">
                <div>
                  <button
                    type="submit"
                    className="flex justify-center px-[2rem] md:px-[2rem] lg:px-[3rem] py-2 text-left  border border-transparent rounded-[9px] shadow-sm text-[14px] lg:text-[16px] text-[#FFFFFF] font-semibold bg-[#D10A11] hover:bg-[#D10A11]  focus:outline-none focus:ring-2 focus:ring-offset-2 "
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
            </form>
          </div>
        </div>
      </section>

      {/* Partner Search  web and tab */}
      <section className="hidden md:block font-segeo  bg-[#FFFFFF]">
        <div className="grid md:grid-cols-10 lg:grid-cols-12 md:pl-[0rem] md:pr-[3rem] lg:px-[5rem] md:gap-8 lg:gap-0">
          <div className="grid grid-cols-12 md:col-span-2 lg:col-span-4 md:my-[9rem] lg:my-[6rem]">
            <div className="md:col-start-3 lg:col-start-2 md:col-span-6 lg:col-span-7 md:pl-[1rem] lg:pl-0">
              <h1 className="text-[#231F20] md:text-[1.8rem] lg:text-[3rem] whitespace-nowrap">
                Your Partner Search
              </h1>
              <h1 className="text-[#D10A11] font-bold md:text-[1.8rem] lg:text-[3rem] whitespace-nowrap">
                Just Got
              </h1>
              <h1 className="text-[#D10A11] font-bold md:text-[1.8rem] lg:text-[3rem]">
                Easier!
              </h1>
            </div>
          </div>

          {/* First Icon */}
          <div className="grid grid-rows-6 col-span-2 space-y-2">
            <div className="row-start-3 row-span-5 realtive md:h-[18rem] lg:h-[20rem] md:w-[9rem] lg:w-[10rem] bg-[#FDECE8] rounded-[6rem] p-[1rem] text-center capsule">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#F7BFB4] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem] mt-4 md:ml-[1rem] lg:ml-[1.1rem]">
                <img
                  className="h-12 w-12"
                  src={AdvisorIcon}
                  alt="AdvisorIcon"
                />
              </div>
              <div>
                <p className="text-[#231F20] md:text-[9px] lg:text-[12px] whitespace-nowrap mt-4 mb-2 font-[550] flex justify-center">
                  MATRIMONY ADVISOR
                </p>
                <p className="text-[#231F20] md:text-[9px] lg:text-[11px]">
                  Our Matrimony Advisor searches and selects matches from Kalyan
                  Matrimony and its partner sites.
                </p>
              </div>
            </div>
          </div>
          {/* Middle Icon 1*/}
          <div className="grid grid-rows-6 col-span-2 space-y-2 my-4 pl-[1rem]">
            <div className="row-span-3 realtive md:h-[18rem] lg:h-[20rem] md:w-[9rem] lg:w-[10rem] bg-[#FDF9F1] rounded-[6rem] p-[1rem] text-center capsule ">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#F7ECD2] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem] mt-4 md:ml-[1rem] lg:ml-[1.1rem]">
                <img
                  className="h-12 w-12"
                  src={AccurateIcon}
                  alt="AdvisorIcon"
                />
              </div>
              <div>
                <p className="text-[#231F20] md:text-[9px] lg:text-[12px] whitespace-nowrap mt-4 mb-2 font-[550] flex justify-center">
                  ACCURATE MATCHES
                </p>
                <p className="text-[#231F20] md:text-[9px] lg:text-[11px]">
                  Our Matrimony Advisor understands your specific expectations and
                  cultural nuances to get you the most accurate matches using our
                  AI algorithm.
                </p>
              </div>
            </div>

            <div className="row-span-3 realtive md:h-[18rem] lg:h-[20rem] md:w-[9rem] lg:w-[10rem] bg-[#FBF1F8] rounded-[6rem] p-[1rem] text-center capsule">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#F2D2E9] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem] mt-4 md:ml-[1rem] lg:ml-[1.1rem]">
                <img
                  className="h-12 w-12"
                  src={VisibilityIcon}
                  alt="AdvisorIcon"
                />
              </div>
              <div>
                <p className="text-[#231F20] md:text-[9px] lg:text-[12px] whitespace-nowrap mt-4 mb-2 font-[550] flex justify-center">
                  INCREASED VISIBILITY
                </p>
                <p className="text-[#231F20] md:text-[9px] lg:text-[11px]">
                  Increased Visibility of your profile in searches with profile
                  enhancements and get more responses.
                </p>
              </div>
            </div>
          </div>
          {/* Middle Icon 2*/}
          <div className="grid grid-rows-6 col-span-2 md:pl-[1rem] lg:pl-[2rem]">
            <div className="row-start-2 row-span-3 realtive md:h-[18rem] lg:h-[20rem] md:w-[9rem] lg:w-[10rem] bg-[#F1FDFB] rounded-[6rem] p-[1rem] text-center capsule">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#D2F7F2] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem] mt-4 md:ml-[1rem] lg:ml-[1.1rem]">
                <img className="h-12 w-12" src={MeetIcon} alt="AdvisorIcon" />
              </div>
              <div>
                <p className="text-[#231F20] md:text-[9px] lg:text-[12px] whitespace-nowrap mt-4 mb-2 font-[550] flex justify-center">
                  MEET YOUR MATCHES
                </p>
                <p className="text-[#231F20] md:text-[9px] lg:text-[11px]">
                  Our Matrimony Advisor facilitates meetings with profiles you are
                  interested in.
                </p>
              </div>
            </div>
          </div>
          {/* Last Icon */}
          <div className="grid grid-rows-6 col-span-2 space-y-2 my-4 md:pl-[1rem] lg:pl-[3rem]">
            <div className="row-span-3 realtive md:h-[18rem] lg:h-[20rem] md:w-[9rem] lg:w-[10rem] bg-[#EAF1E7] rounded-[6rem] p-[1rem] text-center capsule">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#B9D2B0] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem] mt-4 md:ml-[1rem] lg:ml-[1.1rem]">
                <img
                  className="h-12 w-12"
                  src={HoroScopeIcon}
                  alt="AdvisorIcon"
                />
              </div>
              <div>
                <p className="text-[#231F20] md:text-[9px] lg:text-[12px] whitespace-nowrap mt-4 mb-2 font-[550] flex justify-center">
                  HOROSCOPE MATCHING
                </p>
                <p className="text-[#231F20] md:text-[9px] lg:text-[11px]">
                  Our Matrimony Advisor supports you in horoscope matching.
                </p>
              </div>
            </div>

            <div className="row-span-3 realtive md:h-[18rem] lg:h-[20rem] md:w-[9rem] lg:w-[10rem] bg-[#FBE4EA] rounded-[6rem] p-[1rem] text-center capsule">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#F2A7BB] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem] mt-4 md:ml-[1rem] lg:ml-[1.1rem]">
                <img
                  className="h-12 w-12"
                  src={ServiceIcon}
                  alt="AdvisorIcon"
                />
              </div>
              <div>
                <p className="text-[#231F20] md:text-[9px] lg:text-[12px] whitespace-nowrap mt-4 mb-2 font-[550] flex justify-center">
                  SERVICE GUARANTEE!
                </p>
                <p className="text-[#231F20] md:text-[9px] lg:text-[11px] serviceclass">
                  Kalyan Premier is tailored to meet your expectations. However,
                  if you are not happy with our service within the first 7 days of
                  use, we will refund your money back .No questions asked!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Partner Search  mobile */}
      <section className="font-segeo  mt-[3rem] bg-[#FFFFFF] block md:hidden">
         <h1 className="text-[#231F20] flex items-center pl-[3rem] text-[26px] md:text-[1.8rem] lg:text-[2.7rem] whitespace-nowrap">
                Your Partner Search
              </h1>
              <h1 className="text-[#D10A11] flex items-center pl-[3rem] text-[26px] font-bold md:text-[1.8rem] lg:text-[2.7rem] whitespace-nowrap">
                Just Got Easier !
              </h1>
            
            <Slider {...settings} className=" premier-slide mt-[2rem] gap-[2rem] flex overflow-x-auto scrollbar-none">
              <div className=" h-[27rem] w-[13rem] md:w-[9.5rem] lg:w-[10rem] bg-[#FDECE8] rounded-[6rem] p-[2rem] text-center">
                <div className="flex justify-center ">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#F7BFB4] w-[9rem] h-[9rem] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem]">
                <img
                  className="h-[4.5rem] w-[4.5rem]"
                  src={AdvisorIcon}
                  alt="AdvisorIcon"
                />
              </div>
              </div>
              <p className="text-[#231F20] text-[13px] whitespace-nowrap my-4 font-[550]">
                MATRIMONY ADVISOR
              </p>
              <p className="text-[#231F20] text-[13px]">
                Our Matrimony Advisor searches and selects matches from Kalyan
                Matrimony and its partner sites.
              </p>
              </div>
  
              <div className=" h-[27rem] w-[13rem] md:w-[9.5rem] lg:w-[10rem] bg-[#FDF9F1] rounded-[6rem] p-[2rem] text-center">
            <div className="flex justify-center">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#F7ECD2] w-[9rem] h-[9rem] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem]">
                <img
                  className="h-[4.5rem] w-[4.5rem]"
                  src={AccurateIcon}
                  alt="AccurateIcon"
                />
              </div>
              </div>
              <p className="text-[#231F20] text-[13px] whitespace-nowrap my-4 font-[550]">
                 ACCURATE MATCHES
              </p>
              <p className="text-[#231F20] text-[13px]">
                Our Matrimony Advisor understands your specific expectations and cultural nuances to get you the most accurate matches using our AI algorithm.
              </p>
            </div>
              <div className=" h-[27rem] w-[13rem] md:w-[9.5rem] lg:w-[10rem] bg-[#FBF1F8] rounded-[6rem] p-[2rem] text-center">
              <div className="flex justify-center">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#F2D2E9] w-[9rem] h-[9rem] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem]">
                <img
                  className="h-[4.5rem] w-[4.5rem]"
                  src={VisibilityIcon}
                  alt="VisibilityIcon"
                />
              </div>
              </div>
              <p className="text-[#231F20] text-[13px] whitespace-nowrap my-4 font-[550]">
                 INCREASED VISIBILITY
              </p>
              <p className="text-[#231F20] text-[13px]">
                 Increased Visibility of your profile in searches with profile enhancements and get more responses.
              </p>
            </div>
            <div className=" h-[27rem] w-[13rem] md:w-[9.5rem] lg:w-[10rem] bg-[#F1FDFB] rounded-[6rem] p-[2rem] text-center">
           <div className="flex justify-center">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#D2F7F2] w-[9rem] h-[9rem] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem]">
                <img
                  className="h-[4.5rem] w-[4.5rem]"
                  src={MeetIcon}
                  alt="MeetIcon"
                />
              </div>
              </div>
              <p className="text-[#231F20] text-[13px] whitespace-nowrap my-4 font-[550]">
                 MEET YOUR MATCHES
              </p>
              <p className="text-[#231F20] text-[13px]">
                Our Matrimony Advisor facilitates meetings with profiles you are interested in.
              </p>
            </div>
            <div className=" h-[27rem] w-[13rem] md:w-[9.5rem] lg:w-[10rem] bg-[#EAF1E7] rounded-[6rem] p-[2rem] text-center">
            <div className="flex justify-center">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#B9D2B0] w-[9rem] h-[9rem] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem]">
                <img
                  className="h-[4.5rem] w-[4.5rem]"
                  src={HoroScopeIcon}
                  alt="HoroScopeIcon"
                />
              </div>
              </div>
              <p className="text-[#231F20] text-[13px] whitespace-nowrap my-4 font-[550]">
                 HOROSCOPE MATCHING
              </p>
              <p className="text-[#231F20] text-[13px]">
                Our Matrimony Advisor supports you in horoscope matching.
              </p>
            </div>
            <div className=" h-[27rem] w-[13rem] md:w-[9.5rem] lg:w-[10rem] bg-[#FBE4EA] rounded-[6rem] p-[2rem] text-center">
              <div className="flex justify-center ">
              <div className="flex justify-center items-center rounded-[5rem] bg-[#F2A7BB] w-[9rem] h-[9rem] md:w-[5rem] md:h-[5rem] lg:w-[6rem] lg:h-[6rem]">
                <img
                  className="h-[4.5rem] w-[4.5rem]"
                  src={ServiceIcon}
                  alt="ServiceIcon"
                />
              </div>
              </div>
              <p className="text-[#231F20] text-[13px] whitespace-nowrap my-4 font-[550]">
                 SERVICE GUARANTEE!
              </p>
              <p className="text-[#231F20] text-[13px]">
                Kalyan Premier is tailored to meet your expectations. However, if you are not happy with our service within the first 7 days of use, we will refund your money back .No questions asked!
              </p>
            </div>
            {/* <Autoslider /> */}
          
            </Slider>


              <div className="bg-[#FFF6D8] mt-[1rem] rounded-bl-[7rem] p-[1rem] block md:hidden">
                  <h1 className="text-[#231F20] text-[23px] font-bold md:text-[1.5rem] lg:text-[2.7rem]">
                  GET <span className="text-[#D10A11] font-bold text-[23px] ">KALYAN PREMIER</span>{" "}
                  
                </h1>
                <h1 className="text-[#231F20] font-bold text-[23px] lg:text-[2.7rem]" >SERVICE NOW.</h1>
                <div className="col-span-6 col-start-7 mt-[1rem] ">
                  <div className="flex justify-evenly space-x-2 md:p-2 lg:p-4">
                    <img
                      className="h-[2.3rem] flex items-center justify-center "
                      src={CallerIcon}
                      alt="CallerIcon"
                    />
                    <div className="text-center">
                      <h5 className="md:text-[.9rem] lg:text-[1.3rem] text-[#D10A11]">
                        Get Assistance from our Matrimony Advisor for 75 days.
                        <span className="text-[#D10A11]">*</span>
                      </h5>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 md:px-0 lg:px-4">
                    <div>
                      <div className="flex space-x-2 mt-[1rem] lg:space-x-4 md:mt-[0.5rem] lg:mt-[1rem] ">
                        <div className="flex  justify-center items-center">
                          <img
                            className=" w-[1rem]  md:w-[1rem] lg:w-[1.5rem]"
                            src={PhoneBookIcon}
                            alt=""
                          />
                        </div>
                        <p dangerouslySetInnerHTML={{
                      __html: premierPack?.viewPhoneNumber?.replace(
                        "Unlimited",
                        `<span style="color: #D10A11;font-weight: 600;">Unlimited</span>`
                      ),
                    }} className="gap-1 text-[11px] lg:text-[16px] text-[#000000] flex  justify-center items-center">
                        </p>
                      </div>
                      <div className="flex space-x-2 mt-[1rem] lg:space-x-4 md:mt-[0.5rem] lg:mt-[1rem] ">
                        <div className="flex justify-center items-center shrink-0">
                          <img
                            className=" w-[1rem]  md:w-[1rem] lg:w-[2rem] shrink-0"
                            src={HoroIcon}
                            alt=""
                          />
                        </div>
                        <p dangerouslySetInnerHTML={{
                      __html: premierPack?.sendHoroscope?.replace(
                        "Unlimited",
                        `<span style="color: #D10A11;font-weight: 600;">Unlimited</span>`
                      ),
                    }} className="gap-1 text-[11px] lg:text-[16px] text-[#000000] ">
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="flex space-x-2 mt-[1rem] lg:space-x-4 md:mt-[0.5rem] lg:mt-[1rem] ">
                        <div className="flex justify-center items-center">
                          <img
                            className=" w-[1rem]  md:w-[1rem] lg:w-[1.5rem]"
                            src={ChatIcon}
                            alt=""
                          />
                        </div>
                        <p dangerouslySetInnerHTML={{
                      __html: premierPack?.sendMessage?.replace(
                        "Unlimited",
                        `<span style="color: #D10A11;font-weight: 600;">Unlimited</span>`
                      ),
                    }} className="gap-1 text-[11px] lg:text-[16px] text-[#000000] flex  justify-center items-center">
                        </p>
                      </div>
                      <div className="flex space-x-2 mt-[1rem] lg:space-x-4 md:mt-[0.5rem] lg:mt-[1rem] ">
                        <div className="flex justify-center items-center">
                          <img
                            className=" w-[1rem]  md:w-[1rem] lg:w-[1.5rem]"
                            src={StatIcon}
                            alt=""
                          />
                        </div>
                  <p
                    className="gap-1 text-[11px] lg:text-[16px] text-[#000000] flex  justify-center items-center"
                    dangerouslySetInnerHTML={{
                      __html: premierPack?.visiblility?.replace(
                        "Increased",
                        `<span style="color: #D10A11;font-weight: 600;">Increased</span>`
                      ),
                    }}
                  ></p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="md:col-span-7 lg:col-span-6 md:col-start-5 lg:col-start-6">
                  <div className="flex justify-between items-end p-4">
              {
                strikeAmount
                  ? <div >
                    <h1 className="text-[#DF891B] text-[28px] font-bold md:text-[1.7rem] lg:text-[2.7rem] line-through">
                      ₹ {premierPack?.price}
                    </h1>
                    <h1 className="text-[#DF891B] text-[28px] font-bold md:text-[1.7rem] lg:text-[2.7rem]">
                      ₹ {premierPack?.strikePrice}
                    </h1>
                  </div>
                  : <h1 className="text-[#DF891B] text-[28px] font-bold md:text-[1.7rem] lg:text-[2.7rem]">
                    ₹ {premierPack?.price}
                  </h1>
              }
                    <button
                      type="button"
                      onClick={payNowClick}
                      className="flex h-[42px] justify-center px-[4rem] text-left items-center border border-transparent rounded-[24px] shadow-sm md:text-[12px] lg:text-[16px] text-[#FFFFFF] font-semibold bg-[#D10A11] focus:outline-none focus:ring-2 focus:ring-offset-2"
                    >
                      PAY NOW
                    </button>
                  </div>
                </div>
            </div>
      </section>
      
      {/* Premier Service web and tab */}
      <section className="hidden md:block  font-segeo bg-[#FFFFFF] md:p-[3rem] lg:p-[5rem]">
        <div className="grid grid-cols-12">
          <div className="absolute hidden md:block lg:block col-span-4">
            <img
              src={EngagedIcon}
              alt="EngagedIcon"
              className="md:w-[22rem] lg:w-[34rem] 2xl:max-w-[52rem] md:h-[14rem] lg:h-full 2xl:h-[25rem] rounded-[4rem]"
            />
          </div>
          <div className="col-start-2 col-span-11">
            <div className="grid grid-cols-12">
              <div className="col-span-6 col-start-7">
                <h1 className="text-[#231F20] font-black md:text-[1.5rem] lg:text-[2.9rem]">
                  GET <span className="text-[#D10A11]">KALYAN PREMIER</span>{" "}
                  SERVICE NOW.
                </h1>
              </div>
            </div>
            <div className="bg-[#FFF6D8] rounded-bl-[15rem]">
              <div className="grid grid-cols-12">
                <div className="col-span-6 col-start-7">
                  <div className="flex justify-evenly items-center space-x-2 md:p-2 lg:p-4">
                    <img
                      className="h-[2rem] md:h-[4rem] lg:h-[8rem] mt-[.5rem]"
                      src={CallerIcon}
                      alt="CallerIcon"
                    />
                    <div className="text-center">
                      <h5 className="md:text-[.9rem] lg:text-[1.39rem] text-[#D10A11]">
                        Get Assistance from our Matrimony Advisor for 75 days.
                        <span className="text-[#D10A11]">*</span>
                      </h5>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 md:px-0 lg:px-2">
                    <div>
                      <div className="flex md:space-x-2 lg:space-x-4 md:mt-[0.5rem] lg:mt-[1rem] items-center">
                        <div className="flex justify-center items-start">
                          <img
                            className=" w-[1rem]  md:w-[1rem] lg:w-[1.5rem]"
                            src={PhoneBookIcon}
                            alt=""
                          />
                        </div>
                        <p dangerouslySetInnerHTML={{
                      __html: premierPack?.viewPhoneNumber?.replace(
                        "Unlimited",
                        `<span style="color: #D10A11;font-weight: 600;">Unlimited</span>`
                      ),
                    }} className="gap-1 md:text-[9px] lg:text-[16px] text-[#000000] flex  justify-center items-start lg:ml-[1.2rem]">
                         </p>
                      </div>
                      <div className="flex md:space-x-2 lg:space-x-4 md:mt-[0.5rem] lg:mt-[1rem] ">
                        <div className="flex justify-center items-start">
                          <img
                            className=" w-[1rem]  md:w-[1.5rem] lg:w-[2.8rem]"
                            src={HoroIcon}
                            alt=""
                          />
                        </div>
                        <p dangerouslySetInnerHTML={{
                      __html: premierPack?.sendHoroscope?.replace(
                        "Unlimited",
                        `<span style="color: #D10A11;font-weight: 600;">Unlimited</span>`
                      ),
                    }} className="gap-1 md:text-[9px] lg:text-[16px] text-[#000000] flex  justify-center items-start ">
                         </p>
                      </div>
                    </div>
                    <div>
                      <div className="flex md:space-x-2 lg:space-x-4 md:mt-[0.5rem] lg:mt-[1rem] items-center">
                        <div className="flex justify-center items-start">
                          <img
                            className=" w-[1rem]  md:w-[1rem] lg:w-[1.8rem]"
                            src={ChatIcon}
                            alt=""
                          />
                        </div>
                        <p dangerouslySetInnerHTML={{
                      __html: premierPack?.sendMessage?.replace(
                        "Unlimited",
                        `<span style="color: #D10A11;font-weight: 600;">Unlimited</span>`
                      ),
                    }} className="gap-1 md:text-[9px] lg:text-[16px] text-[#000000] flex  justify-center items-start">
                         </p>
                      </div>
                      <div className="flex md:space-x-2 lg:space-x-4 md:mt-[0.5rem] lg:mt-[1rem] ">
                        <div className="flex justify-center items-center">
                          <img
                            className=" w-[1rem]  md:w-[1rem] lg:w-[1.5rem]"
                            src={StatIcon}
                            alt=""
                          />
                        </div>
                        <p dangerouslySetInnerHTML={{
                      __html: premierPack?.visiblility?.replace(
                        "Increased",
                        `<span style="color: #D10A11;font-weight: 600;">Increased</span>`
                      ),
                    }} className="gap-1 md:text-[9px] lg:text-[16px] text-[#000000] flex  justify-center items-start">
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="md:col-span-12 lg:col-span-12 md:col-start-2 lg:col-start-2">
                  <div className="flex justify-end p-4">
                    <div className="flex justify-between gap-8">
                      <div>
                        {
                          strikeAmount
                            ? <div className="flex mr-2">
                              <h1 className="text-[#DF891B] font-bold md:text-[2.7rem] lg:text-[3rem] line-through mr-2">
                                ₹ {premierPack?.price}
                              </h1>
                              <h1 className="text-[#DF891B] font-bold md:text-[2.7rem] lg:text-[3rem]">
                                ₹ {premierPack?.strikePrice}
                              </h1>
                            </div>
                            : <h1 className="text-[#DF891B] font-bold md:text-[2.7rem] lg:text-[3rem]">
                              ₹ {premierPack?.price}
                            </h1>
                        }
                      </div>
                      <div className="place-self-center">
                        <button
                          type="button"
                          onClick={payNowClick}
                          className="flex justify-center md:px-[3rem] lg:px-[5rem] md:py-[.5rem] lg:py-[.5rem] text-left items-center border border-transparent rounded-[10px] shadow-sm md:text-[14px] lg:text-[20px] text-[#FFFFFF] font-extrabold bg-[#D10A11] focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                          PAY NOW
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     
    </>
  );
}

export default NewKalyanPremier;
